/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitAcquisitionState } from '../../models/unit-acquisition-state';
import { UnitAcquisitionUpdate } from '../../models/unit-acquisition-update';

export interface UpdateUnitsAcquisitionParameters$Params {
      body: Array<UnitAcquisitionUpdate>
}

export function updateUnitsAcquisitionParameters(http: HttpClient, rootUrl: string, params: UpdateUnitsAcquisitionParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UnitAcquisitionState>>> {
  const rb = new RequestBuilder(rootUrl, updateUnitsAcquisitionParameters.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UnitAcquisitionState>>;
    })
  );
}

updateUnitsAcquisitionParameters.PATH = '/units/acquisition-parameters';
